/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartQuoteTools',[
    'jquery',
    'global/all',
    './CartManager',
    'global/RocAnalytics'
], function ($, Roc, CartManager, RocAnalytics) {
    'use strict';

    var checkoutUrl = '';
    var savedQuoteCartsUrl = '';
    var punchoutOrder;

    var btns = {
        proceedCheckout: '#btnProceedCheckoutTop',
        viewQuoteCart: '#viewQuoteCartBtn',
        saveQuoteCart: '#saveQuoteCartBtn'
    };

    /* Events */
    function openSaveQuoteCartModalEvt() {
        $(document).on('click', '.openSaveQuoteCartModal', function () {
            Roc.UI.Modal.open('#saveQuoteCartModal');
        });
    }

    function saveQuoteCartEvt() {
        $(document).on('click', btns.saveQuoteCart, function () {
            
            var $form = $('#saveQuoteCartModal');

            var requestData = {
                Email: null,
                QuoteName: null
            };

            //TODO: refactor to use forms
            var validationMsg = '';
            var $quoteName = $form.find('input[name="quoteCartName"]');
            if ($quoteName.val().length === 0) {
                validationMsg += 'Please enter cart name';
            } else {
                requestData.QuoteName = $quoteName.val();
            }

            

            if (validationMsg.length > 0) {
                Roc.UI.displayErrorPopup(validationMsg);
            } else {
                CartManager.saveQuote(requestData.QuoteName, requestData.Email);
                Roc.Core.lockButton(btns.saveQuoteCart);
            }
        });
    }

        function viewSavedQuoteCartEvt() {
            $(document).on('click', btns.viewQuoteCart, $.proxy(function () {
            var redirectUrl = savedQuoteCartsUrl;
            var email = $('#viewQuoteCartModal input[name="email"]').val();
            var regEx = /^[A-Za-z0-9']([\.\-\+]?[a-zA-Z0-9'_])*\@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,5}$/;
            if (regEx.test(email)) {
                Roc.UI.Modal.close();

                redirectUrl += '?Email=' + encodeURIComponent(email);
                window.location.replace(redirectUrl);
                Roc.Core.lockButton(btns.viewQuoteCart);
            } else {
                Roc.UI.displayErrorPopup('There seems to be a problem with the email address. Please enter a valid email address and try again.');
            }
        }, this));
    }

    function viewSavedCartsModalEvt() {
        $(document).on('click', '.viewSavedQuoteCartsBtn', function () {
            Roc.UI.Modal.open('#viewQuoteCartModal');
        });
    }

    

    function saveOrderItem(orderItemId) {
        CartManager.saveOrderItem(orderItemId);
    }

        function afterQuoteOrderCartSaved(data) {
            
        if (data.success) {
           
            var redirectUrl = savedQuoteCartsUrl;

            // close currently open modal
            Roc.UI.Modal.close();

            if ('Email' in data) {
                redirectUrl += '?Email=' + encodeURIComponent(data.Email);
            }
            window.location.replace(redirectUrl);
        } else {
           // Roc.Core.releaseLockButton(btns.saveQuoteCart);
        }
    }

    function emailQuoteCartModal() {
        Roc.UI.Modal.open('#emailQuoteCartModal');
    }

    function emailQuoteCart(url) {
        var email = $('#emailCartModal input[name="email"]').val();
        var regEx = /^[A-Za-z0-9']([\.\-\+]?[a-zA-Z0-9'_])*\@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,5}$/;
        if (regEx.test(email)) {
            $.ajax({
                type: 'POST',
                url: url + '/EmailCart',
                data: JSON.stringify({
                    'email': email
                }),
                contentType: 'application/json; charset=utf-8'
            }).done(function (response) {
                if (response && response.success === true) {
                    Roc.UI.Modal.close();
                } else {
                    Roc.UI.displayErrorPopup();
                }
            }).fail(function (xhr) {
                Roc.UI.ajaxErrorPopup(xhr);
            });

        } else {
            Roc.UI.displayErrorPopup('There seems to be a problem with the email address. Please enter a valid email address and try again.');
        }
    }

    function bindEvents() {
        openSaveQuoteCartModalEvt();
        saveQuoteCartEvt();
        viewSavedCartsModalEvt();
        viewSavedQuoteCartEvt();
         
        Roc.EventManager.bind(Roc.Events.cart.QUOTE_SAVED, afterQuoteOrderCartSaved);
       // Roc.EventManager.bind(Roc.Events.cart.GET_SUMMARY, updateTools);
    }

    function init(options) {
        savedQuoteCartsUrl = options.savedQuoteCartsUrl;
        checkoutUrl = options.checkoutUrl;
        punchoutOrder = options.punchoutOrder;
        bindEvents();
    }

    var CartQuoteTools = {
        init: init,
        emailQuoteCart: emailQuoteCart,
        emailQuoteCartModal: emailQuoteCartModal,
        afterQuoteOrderCartSaved: afterQuoteOrderCartSaved,
        saveOrderItem: saveOrderItem
       // updateTools: updateTools
    };

    Roc.Logger.debug('CartQuoteTools.js Loaded:', CartQuoteTools);

    return CartQuoteTools;
});
